"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initWsgsdkOptions = exports.transformToWebp = exports.dateStringToTimeStamp = exports.findPosterUrl = exports.findSharePath = exports.getXspmInfo = exports.handleToast = exports.addBackListener = exports.PollingScan = undefined;
exports.dateToString = dateToString;
exports.dateToStringFull = dateToStringFull;
exports.leftPad = leftPad;
exports.urlParams = urlParams;
exports.buildPath = buildPath;
exports.formatValue = formatValue;
exports.toFixedTwo = toFixedTwo;
exports.setTitle = setTitle;

var _classCallCheck2 = require("@babel/runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("@babel/runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _webxJs = require("@didi/webx-js");

var _core = require("@mpxjs/core");

var _core2 = _interopRequireDefault(_core);

var _constants = require("../../constants");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

var _this2 = undefined;

function dateToString(time) {
    try {
        if (!time) {
            time = new Date();
        } else {
            time = new Date(time);
        }
        return time.getFullYear() + '-' + leftPad(time.getMonth() + 1) + '-' + leftPad(time.getDate()) + ' ' + leftPad(time.getHours()) + ':' + leftPad(time.getMinutes()) + ':' + leftPad(time.getSeconds());
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('dateToString@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
function dateToStringFull(time) {
    try {
        if (!time) {
            time = new Date();
        } else {
            time = new Date(time);
        }
        return time.getFullYear() + leftPad(time.getMonth() + 1) + leftPad(time.getDate()) + leftPad(time.getHours()) + leftPad(time.getMinutes()) + leftPad(time.getSeconds()) + time.getMilliseconds();
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('dateToStringFull@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
function leftPad(input) {
    try {
        var _char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
        var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
        input = '' + input;
        if (length > input.length) {
            for (var i = 0, count = length - input.length; i < count; i++) {
                input = _char + input;
            }
        }
        return input;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('leftPad@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
function urlParams(obj, isEncode) {
    try {
        isEncode = isEncode !== false;
        var url = '';
        if (_webxJs.utils.isObj(obj)) {
            for (var k in obj) {
                var value = obj[k] !== undefined ? obj[k] : '';
                url += '&' + k + '=' + (isEncode ? encodeURIComponent(value) : value);
            }
        }
        return url ? url.substring(1) : '';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('urlParams@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
function buildPath() {
    try {
        var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        console.log('buildPath', uri);
        var url = uri;
        var paramsObj = params;
        var query = urlParams(paramsObj);
        if (url.search(/\?/) > -1) {
            url = ''.concat(url, '&').concat(query);
        } else {
            url = ''.concat(url, '?').concat(query);
        }
        return url;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('buildPath@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
function formatValue() {
    try {
        var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';
        var origin_number = typeof origin === 'string' ? origin : String(origin);
        if (origin_number.split('.')[1] === '0') {
            return origin_number.split('.')[0];
        } else {
            return origin_number;
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('formatValue@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
} // 小数超过两位 - 保留两位小数进行展示

function toFixedTwo() {
    try {
        var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var digitArr = String(number).split('.') || [];
        var decimal = digitArr[1];
        if (decimal && String(decimal).length > 2) {
            return number.toFixed(2);
        }
        return number;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('toFixedTwo@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
/**
 * 设置页面标题
 * @param {*} title 标题
 */

function setTitle() {
    try {
        var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '滴滴出行';
        if (document) {
            document.title = title;
        }
        if (__mpx_mode__ === 'web' && (0, _webxJs.is)('passenger')) {
            _webxJs.bridge.setTitle(title);
        } else if (__mpx_mode__ !== 'web') {
            _core2.default.setNavigationBarTitle({ title: title });
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('setTitle@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
/**
 * 轮询 可控制开启/暂停
 * @param {*} title 标题
 */

var PollingScan = /*#__PURE__*/exports.PollingScan = function func_trir_731e6d812d6aeced051e8360d6b509e1() {
    function PollingScan(event) {
        try {
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
            (0, _classCallCheck3.default)(this, PollingScan);
            this._timeStamp = 0;
            this._step = 3;
            this._event = event;
            this._duration = duration;
        } catch (e)
                        {
                'use strict';
                var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                    try {
                        JSON.stringify(k);
                        return true;
                    } catch (e) {
                        return false;
                    }
                });
                window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('PollingScan@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                    stack: e.stack,
                    arguments: omegaParams
                }) : '';
                throw e;
            }
    }
    try {
        (0, _createClass3.default)(PollingScan, [
            {
                key: 'start',
                value: function start() {
                    try {
                        var _this = this;
                        if (this._invl !== 0) {
                            clearInterval(this._invl);
                            this._invl = 0;
                        }
                        this._invl = setInterval(function func_trir_3eb6ad3bdbfc9abba2bd21012fa0f550() {
                            try {
                                _this._event('pollingScanTime', { time: _this._timeStamp });
                                _this._timeStamp += _this._step;
                            } catch (e)
                                                                {
                                    'use strict';
                                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                        try {
                                            JSON.stringify(k);
                                            return true;
                                        } catch (e) {
                                            return false;
                                        }
                                    });
                                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_3eb6ad3bdbfc9abba2bd21012fa0f550@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                                        stack: e.stack,
                                        arguments: omegaParams
                                    }) : '';
                                    throw e;
                                }
                        }, this._duration);
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('start@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }
            },
            {
                key: 'pause',
                value: function pause() {
                    try {
                        clearInterval(this._invl);
                        this._invl = 0;
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('pause@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }
            }
        ]);
        return PollingScan;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_731e6d812d6aeced051e8360d6b509e1@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}();
var addBackListener = exports.addBackListener = function addBackListener() {
    try {
        if ((0, _webxJs.is)('passenger')) {
            _webxJs.bridge.setBackPressListener({ listen: true }, function func_trir_466f0b0bf3b1f2be24c41e99d4c1a674() {
                try {
                    _this2.handleTimeCost(function func_trir_674e017a06536bb3fd74d694be53d1f8() {
                        try {
                            console.log('端内点击返回按钮');
                            if (window.history && window.history.length > 1) {
                                window.history.back();
                            } else {
                                console.log('closePage');
                                _webxJs.bridge.closePage({});
                            }
                        } catch (e)
                                                        {
                                'use strict';
                                var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                    try {
                                        JSON.stringify(k);
                                        return true;
                                    } catch (e) {
                                        return false;
                                    }
                                });
                                window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_674e017a06536bb3fd74d694be53d1f8@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                                    stack: e.stack,
                                    arguments: omegaParams
                                }) : '';
                                throw e;
                            }
                    });
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_466f0b0bf3b1f2be24c41e99d4c1a674@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        } else {
            var state = {
                title: 'title',
                url: '#'
            };
            window.history.pushState(state, 'title', '#');
            window.addEventListener('popstate', function func_trir_0f7499d496d4db0b46e3ee0eca2caf45() {
                try {
                    console.log('端外h5监听popstate');
                    _this2.handleTimeCost(function func_trir_4c5c564f9d776e64272b2b4d9607365e() {
                        try {
                            window.history.back();
                        } catch (e)
                                                        {
                                'use strict';
                                var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                    try {
                                        JSON.stringify(k);
                                        return true;
                                    } catch (e) {
                                        return false;
                                    }
                                });
                                window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_4c5c564f9d776e64272b2b4d9607365e@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                                    stack: e.stack,
                                    arguments: omegaParams
                                }) : '';
                                throw e;
                            }
                    });
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_0f7499d496d4db0b46e3ee0eca2caf45@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            }, false);
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('addBackListener@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};
/* 公共toast */

var handleToast = exports.handleToast = function handleToast(title) {
    try {
        _core2.default.showToast({
            title: title,
            icon: 'none',
            duration: 2000
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('handleToast@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};
var getXspmInfo = exports.getXspmInfo = function getXspmInfo(pageStatus) {
    try {
        var c;
        if (pageStatus === _constants.PROCESS_STATUS.RESULT) {
            c = _constants.OPERATION_POSITION.receiveSuccessBtn.id;
        } else {
            c = _constants.OPERATION_POSITION.receiveErrorBtn.id;
        }
        var xspmInfo = {
            a: 'channel-gift',
            b: 'index',
            c: c,
            d: ''
        };
        return xspmInfo;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('getXspmInfo@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};
/* 获取分享跳转地址 */

var findSharePath = exports.findSharePath = function findSharePath() {
    try {
        var _shareConf$channels;
        var shareConf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var xenv = 'wxmp';
        var wx_appmsg = shareConf === null || shareConf === void 0 ? void 0 : (_shareConf$channels = shareConf.channels) === null || _shareConf$channels === void 0 ? void 0 : _shareConf$channels.wx_appmsg;
        var target = '';
        if (wx_appmsg) {
            target = wx_appmsg.find(function func_trir_027c65cf24681f93182b7cbb8d1c4cf1(item) {
                try {
                    return item.xenv === xenv;
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_027c65cf24681f93182b7cbb8d1c4cf1@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        }
        var path = target ? target.path : (0, _webxJs.build)('/webx/entry/ut', { dchn: (0, _webxJs.query)().dchn });
        return path;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('findSharePath@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};
/* 获取海报图片地址 */

var findPosterUrl = exports.findPosterUrl = function findPosterUrl() {
    try {
        var _webxConfig$conf, _webxConfig$conf$ext, _webxConfig$conf2, _webxConfig$conf2$ext, _webxConfig$conf2$ext2;
        var webxConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var poster = '';
        var posterUrl = '';
        if ((_webxConfig$conf = webxConfig.conf) !== null && _webxConfig$conf !== void 0 && (_webxConfig$conf$ext = _webxConfig$conf.ext) !== null && _webxConfig$conf$ext !== void 0 && _webxConfig$conf$ext.presetShare_conf && (_webxConfig$conf2 = webxConfig.conf) !== null && _webxConfig$conf2 !== void 0 && (_webxConfig$conf2$ext = _webxConfig$conf2.ext) !== null && _webxConfig$conf2$ext !== void 0 && (_webxConfig$conf2$ext2 = _webxConfig$conf2$ext.presetShare_conf) !== null && _webxConfig$conf2$ext2 !== void 0 && _webxConfig$conf2$ext2.poster) {
            var _webxConfig$conf3, _webxConfig$conf3$ext, _webxConfig$conf3$ext2;
            if (((_webxConfig$conf3 = webxConfig.conf) === null || _webxConfig$conf3 === void 0 ? void 0 : (_webxConfig$conf3$ext = _webxConfig$conf3.ext) === null || _webxConfig$conf3$ext === void 0 ? void 0 : (_webxConfig$conf3$ext2 = _webxConfig$conf3$ext.presetShare_conf) === null || _webxConfig$conf3$ext2 === void 0 ? void 0 : _webxConfig$conf3$ext2.poster.indexOf('http')) > -1) {
                var _webxConfig$conf4, _webxConfig$conf4$ext, _webxConfig$conf4$ext2;
                poster = (_webxConfig$conf4 = webxConfig.conf) === null || _webxConfig$conf4 === void 0 ? void 0 : (_webxConfig$conf4$ext = _webxConfig$conf4.ext) === null || _webxConfig$conf4$ext === void 0 ? void 0 : (_webxConfig$conf4$ext2 = _webxConfig$conf4$ext.presetShare_conf) === null || _webxConfig$conf4$ext2 === void 0 ? void 0 : _webxConfig$conf4$ext2.poster;
            } else {
                var _webxConfig$conf5, _webxConfig$conf5$ext, _webxConfig$conf5$ext2;
                poster = ''.concat(_constants.DCHN_PATH).concat((_webxConfig$conf5 = webxConfig.conf) === null || _webxConfig$conf5 === void 0 ? void 0 : (_webxConfig$conf5$ext = _webxConfig$conf5.ext) === null || _webxConfig$conf5$ext === void 0 ? void 0 : (_webxConfig$conf5$ext2 = _webxConfig$conf5$ext.presetShare_conf) === null || _webxConfig$conf5$ext2 === void 0 ? void 0 : _webxConfig$conf5$ext2.poster);
            }
            posterUrl = (0, _webxJs.build)(poster || ''.concat(_constants.DCHN_PATH).concat((0, _webxJs.query)().dchn), { xpsid_share: webxConfig.xpsid });
            console.log('海报地址', posterUrl);
        }
        return posterUrl;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('findPosterUrl@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};
var dateStringToTimeStamp = exports.dateStringToTimeStamp = function dateStringToTimeStamp() {
    try {
        var date_string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var formatted = date_string.replace(/-/g, '/');
        var time_stamp = Date.parse(formatted);
        return time_stamp;
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('dateStringToTimeStamp@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};
var transformToWebp = exports.transformToWebp = function transformToWebp() {
    try {
        var imgs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        if (_webxJs.utils.isArray(imgs)) {
            return imgs.map(function func_trir_e9a3961e6ad45aa19e905087eed39fdd(item) {
                try {
                    return _webxJs.utils.webpUrl(item);
                } catch (e)
                                        {
                        'use strict';
                        var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                            try {
                                JSON.stringify(k);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        });
                        window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_e9a3961e6ad45aa19e905087eed39fdd@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                            stack: e.stack,
                            arguments: omegaParams
                        }) : '';
                        throw e;
                    }
            });
        } else if (_webxJs.utils.isStr(imgs)) {
            return _webxJs.utils.webpUrl(imgs);
        } else {
            return '';
        }
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('transformToWebp@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};
var initWsgsdkOptions = exports.initWsgsdkOptions = function initWsgsdkOptions() {
    try {
        import('@didi/wsgsdk').then(function func_trir_81b11fa290bf437c6607923f025d622e(module) {
            try {
                console.log({ module: module });
                module.ddClg({
                    omega: window.Omega,
                    domainList: ['www.udache.com']
                });
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_81b11fa290bf437c6607923f025d622e@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        })['catch'](function func_trir_c03ba79946b0bcc48df781679525b49e(err) {
            try {
                console.error('wsgsdk加载失败', err);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('func_trir_c03ba79946b0bcc48df781679525b49e@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        });
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('initWsgsdkOptions@@../../../../src/lib/js/util.js@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
};